import { initI18n as _initI18n, initI18nWithoutICU as _initI18nWithoutICU, } from '@wix/fe-essentials/i18n';
export var initI18n = _initI18n;
export var initI18nWithoutICU = _initI18nWithoutICU;
//# sourceMappingURL=init.js.map